"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { Link } from "@nxt-costco-com/forge-components";
import { Analytics } from "../../../Analytics/index.js";
import { useCartContext } from "../../../Chrome/CartContext/hook.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import { Badge } from "./Badge.js";
import { CART_MAX_ITEMS } from "./constants.js";
import { getCartAriaLabel } from "./lib.js";
import { CartIcon, CartText } from "./styles.js";
function CartSystemDefinedLink({
  entry
}) {
  const { cartItemCount } = useCartContext();
  if (!entry) return null;
  return /* @__PURE__ */ jsx(
    Analytics,
    {
      analyticData: {
        component: {
          trackedData: [
            entry.active_state.active_state_link.title
          ]
        }
      },
      children: /* @__PURE__ */ jsxs(
        Link,
        {
          "aria-label": cartItemCount === 0 ? entry.active_state.active_state_link.title : getCartAriaLabel(
            cartItemCount,
            entry.active_state.active_state_link.title,
            entry.active_state.properties[0].descriptionSingleItem,
            entry.active_state.properties[0].descriptionMultipleItems
          ),
          sx: {
            alignItems: "center",
            display: "flex",
            flexDirection: { lg: "row", xs: "column" },
            width: "fit-content"
          },
          "data-testid": "cart-link",
          href: entry.active_state.active_state_link.href,
          children: [
            /* @__PURE__ */ jsx(
              CostcoBox,
              {
                sx: {
                  width: "fit-content"
                },
                children: /* @__PURE__ */ jsx(
                  Badge,
                  {
                    badgeContent: cartItemCount,
                    "data-testid": "cart-badge",
                    max: CART_MAX_ITEMS,
                    children: /* @__PURE__ */ jsx(CartIcon, {})
                  }
                )
              }
            ),
            /* @__PURE__ */ jsx(CartText, { "aria-hidden": true, "data-testid": "cart", children: entry.active_state.active_state_link.title })
          ]
        }
      )
    }
  );
}
export {
  CartSystemDefinedLink
};
